import { FormControlLabel, styled, Switch } from '@mui/material';
import React from 'react';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 37,
  height: 19,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 3.5,
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& .MuiSwitch-thumb': {
        backgroundColor: '#171D40' // Thumb color when checked
      },
      '& + .MuiSwitch-track': {
        borderRadius: 22 / 2,
        opacity: 1,
        backgroundColor: '#ffffff', // Track background color when unchecked
        border: '2px solid #171D40', // Track border color when unchecked
        boxSizing: 'border-box',
        transition: theme.transitions.create(['background-color', 'border'])
      }
    }
  },
  '& .MuiSwitch-thumb': {
    width: 12,
    height: 12,
    boxShadow: 'none',
    backgroundColor: 'rgba(0,0,0,.25)' // Thumb color when unchecked
  },
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    opacity: 1,
    backgroundColor: '#ffffff', // Track background color when unchecked
    border: '2px solid rgba(0,0,0,.25)', // Track border color when unchecked
    boxSizing: 'border-box',
    transition: theme.transitions.create(['background-color', 'border'])
  }
}));

export default function SwitchButton({ value, handleChange, inputProps = {} }) {
  return (
    <FormControlLabel
      sx={{ margin: 0 }}
      control={
        <CustomSwitch checked={value} onChange={handleChange} inputProps={inputProps}/>
      }
    />
  );
}
